
/** @format */

import React, { useEffect, useRef } from 'react';
import { PageContainer, ButtonLoading, LoadingPage, StepperKeeper, Icons } from 'components';
import { validator } from 'myValidation';
import { animateScroll as scroll } from 'react-scroll';
import { useForm, FormProvider } from 'react-hook-form';
import persianJs from 'persianjs';
import { useNavigate } from 'react-router-dom';
import DetailsDg from './components/DetailsDg';
import ErrorDelegationDg from './components/ErrorDelegationDg';
import CartableMessageDg from './components/CartableMessageDg';
import RepeatitiveFileDg from './components/RepeatitiveFileDg';
import { Grid, Button } from '@mui/material';
import { useBusiness } from 'hooks';
import CreditTransferServices from './services/CreditTransferServices';
import { BaseInfo, Constraints } from './components';
import createToast from 'components/Toast/Toast';
import jMoment from 'moment-jalaali';
import useCustomHook from './hooks';
import { useStyles } from './style';
import { getDynamicObjectAction, constBreadCrumbsTitle } from 'utility';

export const USE_PERIODS = [
  { value: 'DAY_PERIOD', label: 'روز' },
  { value: 'MONTH_PERIOD', label: 'ماه' },
  { value: 'YEAR_PERIOD', label: 'سال' },
];

const DelegationByMenu = () => {
  // -- STATES --//
  const {
    methodType,
    setMethodtype,
    selectCheckBox,
    setSelectCheckBox,
    isGroup, setIsGroup,
    expireDate,
    setExpireDate,
    startDate,
    setStartDate,
    rowsWithError,
    setRowsWithError,
    isResultErrorsOpen,
    setIsResultErrorsOpen,
    file,
    setFile,
    guilds,
    setGuilds,
    usages,
    setUsages,
    selectedProducts,
    setSelectedProducts,
    usageEnabled,
    setUsageEnabled,
    periodicEnabled,
    setPeriodicEnabled,
    usageLimitsEnabled,
    setUsageLimitsEnabled,
    usagePeriodEnabled,
    setUsagePeriodEnabled,
    balance,
    setBalance,
    foundUser,
    setFoundUser,
    submitting,
    setSubmitting,
    isConfirmModalOpen,
    setIsConfirmModalOpen,
    activeStep,
    setActiveStep,
    infoType, setInfoType,
    dataType, setDataType,
    enteredCaptcha, setEnteredCaptcha, //مقدار کپچا در دیالوگ 
    captchaIdDialog, setCaptchaIdDialog, // شناسه کپچا در دیالوگ اولیه 
    isOpenCartableMessageDg,
    setIsOpenCartableMessageDg,
    requestId,
    setRequestId,
    dataCartable, setDataCartable,
    isCartableLoading, setIsCartableLoading,
    isCartable, setIsCartable,
    captchaIdForm, setCaptchaIdForm,
    enteredCaptchaForm, setEnteredCaptchaForm,
    groupRequestId, setGroupRequestId,
    isLoadingAcceptReaptiveDg, setIsLoadingAcceptReaptiveDg,
    enteredCaptchaRepeat, setEnteredCaptchaRepeat,
    isOpenRepeativeDg, setIsOpenRepeativeDg,
    captchaIdDialogRepeat, setCaptchaIdDialogRepeat,
  } = useCustomHook();

  // -- HOOKS --//
  const methods = useForm();
  const { handleSubmit, reset, formState: { errors }, watch, getValues, setValue } = methods;
  const classes = useStyles();
  const captchaRef = useRef();
  const captchaFormRef = useRef();
  const captchaDialogRef = useRef(); // رفرنس کد کپچا دیالوگ فایل تکراری
  const business = useBusiness();

  const navigate = useNavigate();
  let actionsList = getDynamicObjectAction([
    'contentsDelegationPage',
    'multipleAccountDelegationBtn',
    'multipleAccountDelegationGuildBtn'
  ]);
  useEffect(() => {
    setIsGroup(false);
    if (actionsList['contentsDelegationPage']) {
      getBalanceDetail();
    }

    setValue('usePeriod', null);
    return () => { };
  }, []);
  useEffect(() => { // با تغییر تب تفویض وجه تکی گروهی - حساب دیجیتال حساب تفصیلی ، فایل خالی میشود که دوباره فایل را انتخاب کند
    setFile(null);
  }, [isGroup])


  useEffect(() => { // هر موقع دیالوگ جزییات بسته شود این تابع کال میشود
    if (!isConfirmModalOpen) {
      setEnteredCaptcha('');
    }
  }, [isConfirmModalOpen])

  useEffect(() => { // در تب گروهی اگه کاربر به اشتباه وارد کند به خطا میخورد و مجدد ولیدشن کد امنیتی رفرش میشود
    methods.setValue('captchaValue', enteredCaptchaForm);
  }, [enteredCaptchaForm])

  /**
   * دریافت اطلاعات حساب از سرویس - این سرویس فقط یکبار در این صفحه کال میشه و دیگه نیازی به کال کردن این سرویس نداریم و دیتاشو به بقیه کامپوننت ها ارسال میکنیم و به همین سادگی credit
   */
  const getBalanceDetail = async () => {
    CreditTransferServices.checkBalance().then(res => {
      setBalance(res?.result)
    }).catch(error => { })
  }

  /**
   * این اکشن داره چک میکنه اگه فیلد اجباری پر نشده باشه به کاربر خطارو توست نشون میده
   */
  useEffect(() => {
    if (methods.formState.errors && Object.keys(methods.formState.errors).length > 0 && methods.formState.submitCount > 0 && activeStep == 1) {
      createToast('خطا', errorsToStr(methods.formState.errors), 'danger')
    }
  }, [methods.formState.submitCount]);
  const errorsToStr = (errs) => {
    if (!errs) return null;
    return (
      <div>
        {Object.keys(errs).map((v) => (
          <li>{errs[v]?.message}</li>
        ))}
      </div>
    );
  };

  useEffect(() => {
    if (!watch('usePeriod')) {
      methods.unregister('usePeriod');
      methods.unregister('usePeriodCount');
      return () => { };
    }
  }, [methods.register, methods.unregister, watch('usePeriod')]);

  useEffect(() => {
    if (!watch('usePeriod')) {
      setValue('usePeriodCount', '');
      return () => { };
    }
  }, [watch('usePeriod')]);


  /**
   * اینجا بررسی میکنیم کدوم تب و چه نوع حسابی هستیم 
   */
  const checkFinalServiceCall = () => {
    if (isGroup) { // گروهی
      if (methodType == 'wallet') {
        return 'group_wallet';
      } else {
        return 'group_credit'
      }
    } else { // فردی
      if (methodType == 'wallet') {
        return 'single_wallet';
      } else {
        return 'single_credit'
      }
    }
  }
  /**
   * از داخل آبجکت اگه فیلدی مقدار نداشته باشد، آن فیلد حذف خواهد شد
   */
  const deleteNullValueFromObj = (obj) => {
    Object.keys(obj).forEach((key) => {
      if (obj[key] === null || obj[key] === '' || obj[key] === undefined) {
        delete obj[key];
      }
    });
  }

  const onClickTaeid = () => {
    if (isGroup) {
      taeidNahaeiGroup(true);
    } else {
      onTransfer()
    }
  }

  /**
   * وقتی توی دیالوگ جزییات دکمه تایید رو کلیک میکنیم و اگه از نوع تکی باشد 
   */
  const onTransfer = async () => {
    if (submitting) return;
    if (isGroup) { // بنا به باگی که بر اثر استیت های ریکت پیش میومد این خط کد رو محض احتیاط اینجا نوشتم
      taeidNahaeiGroup(true);
      return
    }

    // usage limits count and period
    let maxTryCount = null;
    let usePeriod = null;
    let usePeriodCount = null;

    if (usageLimitsEnabled) {
      maxTryCount = getValues('maxTryCount') ? parseInt(getValues('maxTryCount')) : null;
      usePeriod = usagePeriodEnabled ? getValues('usePeriod') : 'NO_PERIOD';
      usePeriodCount =
        !getValues('usePeriod') || !usagePeriodEnabled
          ? null
          : getValues('usePeriodCount')
            ? parseInt(getValues('usePeriodCount'))
            : null;
    }

    setSubmitting(true);
    try {
      const body = {
        allPermittedInUse: selectCheckBox,
        amount: getValues('amount'),
        description: getValues('description') || '',
        userId: foundUser?.linkedUser?.id,
        currencyCode: getValues('guildCode')?.currency?.code ?? 'IRR',
        uniqueId: getValues('uniqueId'),
        captchaId: captchaIdDialog,
        captchaAnswer: enteredCaptcha,
        // date limits
        startDate: startDate
          ? persianJs(`${startDate.format('jYYYY/jMM/jDD 00:00')}`)
            .persianNumber()
            .toString()
          : null,
        expireDate: expireDate
          ? persianJs(`${expireDate.format('jYYYY/jMM/jDD 23:59')}`)
            .persianNumber()
            .toString()
          : null,

        // if usageEnabled
        permittedGuildCode: usageEnabled
          ? guilds.length > 0
            ? guilds.map((v) => v?.code)
            : []
          : [],
        permittedBusinessId: usageEnabled
          ? usages.length > 0
            ? usages.map((v) => v?.id)
            : []
          : [],
        permittedProductId:
          usageEnabled && selectedProducts
            ? selectedProducts.length > 0
              ? selectedProducts.map((v) => v?.id)
              : []
            : [],

        // if usageLimitsEnabled
        maxTryCount: usageLimitsEnabled ? maxTryCount : null,
        usePeriod: usageLimitsEnabled && usagePeriodEnabled ? usePeriod : null,
        usePeriodCount: usageLimitsEnabled && usagePeriodEnabled ? usePeriodCount : null,

        // if periodicEnabled
        periodCode: periodicEnabled ? getValues('periodCode') ?? 'NO_PERIOD' : 'NO_PERIOD',
        periodCount: periodicEnabled ? getValues('periodCount') ?? 0 : 0,
      };

      const whichStep = checkFinalServiceCall(); // اینجا مشخص میکنیم توی کدوم تب هستیم که بتونیم مقدار صحیح رو بفرستیم
      if (whichStep == 'single_wallet' || whichStep == 'group_wallet') { //  تکی - دیجیتتال
        body.wallet = 'PODLAND_WALLET';
      } else if (whichStep == 'single_credit' || whichStep == 'group_credit') { //   تکی تفصیلی - گروهی تفصیلی
        body.guildCode = getValues('guildCode')?.code;
      }

      if (isCartable) { // کارتابلی هست
        body['cartableId'] = dataCartable?.multiConfirmationSrv?.id;
        body['description'] = body['description'] || '';


        let res = await CreditTransferServices.requestDelegationSingleCartable(body);
        setRequestId(res?.result?.id);
        setIsOpenCartableMessageDg(true);
        setFile(null);
      } else { // کارتابلی نیست
        await CreditTransferServices.transfer(body);
        navigate('/DefineDelegation/List');
      }

      handleSubmitEnd();
      scroll.scrollToTop();

      const successText = isGroup
        ? 'درخواست تفویض وجه با موفقیت ثبت شد و در صف قرار گرفت!'
        : 'تفویض وجه با موفقیت انجام شد!';

      createToast(' موفق  ', successText, 'success');
    } catch (error) {
      captchaRef?.current?.onMakeCaptcha();
    } finally {
      setSubmitting(false);
    }
  };


  const onGetCartableList = async (data) => {

    setIsCartableLoading(true);
    let cartableParams = {
      offset: 0,
      size: 10,
      typeCode: 'MULTI_CONFIRMATION_TYPE_DELEGATION_RULE',
    };
    if (isGroup) { // گروهی است
      if (methodType === 'wallet') { // دیجیتال است   ==== credit || wallet
        cartableParams['wallet'] = 'PODLAND_WALLET';
      } else { // تفصیلی
        cartableParams['guildCode'] = data?.guildCode?.code
      }
    } else { // تکی
      if (methodType === 'wallet') { // دیجیتال است   ==== credit || wallet
        cartableParams['wallet'] = 'PODLAND_WALLET';
      } else { // تفصیلی
        cartableParams['guildCode'] = data?.guildCode?.code
      }
    }
    try {
      const cartableList = await CreditTransferServices.getCarTableList(cartableParams);
      if (cartableList?.result && cartableList?.result.length > 0 && cartableList?.result[0]?.multiConfirmationSrv?.enable && !cartableList?.result[0]?.multiConfirmationSrv?.left) {
        setIsCartable(true);
      } else {
        setIsCartable(false);
      }
      setDataCartable(cartableList?.result[0]);
      setIsCartableLoading(false);
      return cartableList;
    } catch (error) {
      setIsCartableLoading(false);
    }

  }
  /**
   * ابتدا این تابع کال میشود در زمانیکه از نوع تکی است 
   */
  const onCheckContact = async (data) => {
    try {
      if (methodType === 'credit' && !getValues('guildCode')) {
        return createToast(' خطا  ', 'ابتدا حساب تفصیلی مبدا را انتخاب کنید.', 'danger');
      }
      await onGetCartableList(data);

      const body = {
        firstName: data?.contactInfo,
        lastName: data?.contactInfo,
      };
      setDataType(data?.contactInfo)
      if (!isGroup) { // تفویض وجه تکی
        if (validator.isEmail(data?.contactInfo ?? '')) {
          body.email = data?.contactInfo;
          setInfoType('ایمیل')
        } else if (validator.isMobilePhone(data?.contactInfo ?? '')) {
          setInfoType('تلفن‌همراه')
          body.cellphoneNumber = data?.contactInfo;
        } else if (validator.matches(data?.contactInfo ?? '', /([A-Za-z0-9._-]){3,63}/)) {
          body.username = data?.contactInfo;
          setInfoType('نام کاربری')

        } else {
          createToast(' خطا  ', 'تلفن ، ایمیل یا نام کاربری مخاطب معتبر نمی‌باشد.!', 'danger');
          return;
        }
        setSubmitting(true);
        const r = await CreditTransferServices.checkContact(body);

        if (r.result?.length > 0) {
          if (r.result[0]?.linkedUser?.id == business?.userId) {
            createToast(' خطا  ', 'امکان تخصیص اعتبار به خودتان وجود ندارد!', 'danger');

            setSubmitting(false);
            return;
          } else if (!r.result[0]?.linkedUser) {
            createToast(' خطا  ', 'مخاطب پیدا نشد', 'danger');

            setSubmitting(false);
            return;
          }
          setFoundUser(r.result[0]);
        } else {
          setSubmitting(false);
          return createToast(' خطا  ', 'کاربری با این اطلاعات یافت نشد!', 'danger');
        }
      }
      setIsConfirmModalOpen(true);
      setSubmitting(false);
    } catch (error) {
      setSubmitting(false);
    }
  };


  /**
   * زمانیکه که از نوع گروهی هستیم و فایلی تکراری آپلود کردیم و میخواهیم همون فایل رو آپلود کنیم
   */
  const onRepeatUploadGroup = async () => {
    try {
      setIsLoadingAcceptReaptiveDg(true);
      let maxTryCount = null;
      let usePeriod = null;
      let usePeriodCount = null;

      // if (usageLimitsEnabled) {
      maxTryCount = getValues('maxTryCount') ? parseInt(getValues('maxTryCount')) : null;
      usePeriod = usagePeriodEnabled ? getValues('usePeriod') : 'NO_PERIOD';
      usePeriodCount =
        !getValues('usePeriod') || !usagePeriodEnabled
          ? null
          : getValues('usePeriodCount')
            ? parseInt(getValues('usePeriodCount'))
            : null;
      //}

      const query = {
        'guildCode': methodType === 'credit' ? getValues('guildCode')?.code : null,
        'wallet': methodType === 'wallet' ? 'PODLAND_WALLET' : null,
        'startDate': startDate
          ? persianJs(`${startDate.format('jYYYY/jMM/jDD 00:00')}`)
            .persianNumber()
            .toString()
          : null,
        'permittedGuildCode': usageEnabled
          ? guilds.length > 0
            ? guilds.map((v) => v?.code)
            : []
          : [],
        'permittedProductId':
          usageEnabled && selectedProducts
            ? selectedProducts.length > 0
              ? selectedProducts.map((v) => v?.id)
              : []
            : [],
        'permittedBusinessId': usageEnabled
          ? usages.length > 0
            ? usages.map((v) => v?.id)
            : []
          : [],
        'maxTryCount': usageLimitsEnabled ? maxTryCount : null,
        'usePeriod': usageLimitsEnabled && usagePeriodEnabled ? usePeriod : null,
        'usePeriodCount': usageLimitsEnabled && usagePeriodEnabled ? usePeriodCount : null,
        'periodCode': periodicEnabled ? getValues('periodCode') ?? 'NO_PERIOD' : 'NO_PERIOD',
        'periodCount': periodicEnabled ? getValues('periodCount') ?? 0 : 0,
        'requestTypeCode': 'MULTI_CONFIRMATION_TYPE_DELEGATION_RULE',
        cartableId: dataCartable?.multiConfirmationSrv?.id || null,
        amount: getValues('amount'),
        description: getValues('description') ? String(getValues('description')).trim() : '',
        type: `${isCartable ? 'DELEGATION_CARTABLE' : 'DELEGATION'}`, //CONTACT, CONTACT_CARTABLE, DELEGATION, DELEGATION_CARTABLE
        currencyCode: getValues('guildCode')?.currency?.code ?? 'IRR',
        captchaAnswer: enteredCaptchaRepeat || 'aa',
        captchaId: captchaIdDialogRepeat || 'aa',
        userConfirmed: true,
        hash: file[0]?.hash || null
      };
      deleteNullValueFromObj(query)
      const uploadFileRes = await CreditTransferServices.delegationGroup(query);
      setGroupRequestId(uploadFileRes?.result?.requestId)
      setIsConfirmModalOpen(true);
      setIsOpenRepeativeDg(false);
      setIsLoadingAcceptReaptiveDg(false);
    } catch (error) {
      captchaDialogRef?.current?.onMakeCaptcha();
      setIsLoadingAcceptReaptiveDg(false);
      const errMsg = error?.response?.data?.message;
      if (error?.response?.status === 415) {
        setFile(null);
        if (errMsg) {
          // "$" sign as seperator of multiple messages
          const errs = errMsg.split('$');
          setRowsWithError(errs);
          setIsOpenRepeativeDg(false);
          return setIsResultErrorsOpen(true);
        }
      } else {
        createToast('خطا', error?.response?.data?.message || 'خطا در انجام عملیات', 'danger')
      }
    }
  }

  /**
   * زمانیکه از نوع گروهی هستیم 
   */
  const onUploadGroup = async (data) => {
    if (file?.length === 0 || file === null) {
      return createToast(' خطا  ', 'ابتدا فایل را انتخاب کنید!', 'danger');
    }
    if (methodType === 'credit' && !getValues('guildCode')) {
      return createToast(' خطا  ', 'ابتدا حساب تفصیلی مبدا را انتخاب کنید.', 'danger');
    }
    if (activeStep == 1 && !String(enteredCaptchaForm).trim()) {
      return createToast(' خطا  ', 'لطفا کد امنیتی را وارد کنید.');
    }
    try {
      const resultCartabl = await onGetCartableList(data);

      setSubmitting(true);
      let maxTryCount = null;
      let usePeriod = null;
      let usePeriodCount = null;

      // if (usageLimitsEnabled) {
      maxTryCount = getValues('maxTryCount') ? parseInt(getValues('maxTryCount')) : null;
      usePeriod = usagePeriodEnabled ? getValues('usePeriod') : 'NO_PERIOD';
      usePeriodCount =
        !getValues('usePeriod') || !usagePeriodEnabled
          ? null
          : getValues('usePeriodCount')
            ? parseInt(getValues('usePeriodCount'))
            : null;
      //}

      const query = {
        'guildCode': methodType === 'credit' ? getValues('guildCode')?.code : null,
        'wallet': methodType === 'wallet' ? 'PODLAND_WALLET' : null,
        'startDate': startDate
          ? persianJs(`${startDate.format('jYYYY/jMM/jDD 00:00')}`)
            .persianNumber()
            .toString()
          : null,
        'permittedGuildCode': usageEnabled
          ? guilds.length > 0
            ? guilds.map((v) => v?.code)
            : []
          : [],
        'permittedProductId':
          usageEnabled && selectedProducts
            ? selectedProducts.length > 0
              ? selectedProducts.map((v) => v?.id)
              : []
            : [],
        'permittedBusinessId': usageEnabled
          ? usages.length > 0
            ? usages.map((v) => v?.id)
            : []
          : [],
        'maxTryCount': usageLimitsEnabled ? maxTryCount : null,
        'usePeriod': usageLimitsEnabled && usagePeriodEnabled ? usePeriod : null,
        'usePeriodCount': usageLimitsEnabled && usagePeriodEnabled ? usePeriodCount : null,
        'periodCode': periodicEnabled ? getValues('periodCode') ?? 'NO_PERIOD' : 'NO_PERIOD',
        'periodCount': periodicEnabled ? getValues('periodCount') ?? 0 : 0,
        'requestTypeCode': 'MULTI_CONFIRMATION_TYPE_DELEGATION_RULE',
        cartableId: resultCartabl?.result[0]?.multiConfirmationSrv?.id,
        amount: getValues('amount'),
        description: getValues('description') ? String(getValues('description')).trim() : '',
        type: `${resultCartabl.result.length > 0 ? 'DELEGATION_CARTABLE' : 'DELEGATION'}`, //CONTACT, CONTACT_CARTABLE, DELEGATION, DELEGATION_CARTABLE
        currencyCode: getValues('guildCode')?.currency?.code ?? 'IRR',
        captchaAnswer: enteredCaptchaForm || 'aa',
        captchaId: captchaIdForm || 'aa',
        hash: file[0]?.hash || null
      };

      // const formData = new FormData();
      // formData.append('file', file);
      deleteNullValueFromObj(query)
      const uploadFileRes = await CreditTransferServices.delegationGroup( query, file.name, file.type);
      setGroupRequestId(uploadFileRes?.result?.requestId)
      setIsConfirmModalOpen(true);
      setSubmitting(false);
      captchaFormRef?.current?.onMakeCaptcha();
    } catch (error) {
      setSubmitting(false);
      captchaFormRef?.current?.onMakeCaptcha();
      if (error?.response?.status != 409 && error?.response?.status != 415 && error?.config?.headers?.idToken) {
        createToast('خطا', error?.response?.data?.message || 'خطا در انجام عملیات', 'danger');
      }
      const errMsg = error?.response?.data?.message;
      if (error?.response?.status === 415) {
        if (errMsg) {
          // "$" sign as seperator of multiple messages
          const errs = errMsg.split('$');
          setRowsWithError(errs);
          return setIsResultErrorsOpen(true);
        }
      }

      if (error?.response?.status == 409) {  // این کد خطا به این معنی است که کاربر داره فایلی ارسال میکند که انتقال وجه تکراری است
        setIsOpenRepeativeDg(true);
        return;
      }
    }
  }
  /**
   * در نهایت تایید نهایی گروهی مون این تابع خواهد بود.دکمه تایید دیالوگ تایید نهایی اطلاعات 
   */
  const taeidNahaeiGroup = async (isConfirmd = true) => {
    try {

      if (isConfirmd == false) {
        setIsConfirmModalOpen(false);
        setFile(null);
      }
      if (isConfirmd == true) {
        setSubmitting(true);
      }

      const obj = {

        captchaId: captchaIdDialog || 'a',
        captchaAnswer: enteredCaptcha || 'a',
        confirmed: isConfirmd,
        type: `${isCartable ? 'DELEGATION_CARTABLE' : 'DELEGATION'}`, //CONTACT, CONTACT_CARTABLE, DELEGATION, DELEGATION_CARTABLE
      };
      const headers = {
        idToken: 'true',
      };

      const res = await CreditTransferServices.confirmDelegationByGroup(groupRequestId, obj, headers)

      if (isConfirmd) {
        //setIsOpenMessageDg(true);
        createToast('موفق', 'عملیات با موفقیت انجام شد.', 'success');
        setFile(null);
      }
      setIsConfirmModalOpen(false);
      setSubmitting(false);
      isConfirmd && setIsOpenCartableMessageDg(true);

    } catch (error) {
      captchaFormRef?.current?.onMakeCaptcha();
      if (error?.response?.status === 400) {

        isConfirmd && createToast('خطا', error?.response?.data?.message || 'عملیات انجام نشد، لطفا مجدد تلاش نمایید', 'danger')
      } else {
        isConfirmd && createToast('خطا', 'عملیات انجام نشد، لطفا مجدد تلاش نمایید', 'danger')
      }
      if (isConfirmd) {
        captchaRef?.current?.onMakeCaptcha();
      }
      //setIsConfirmModalOpen(false);
      setSubmitting(false);
    }

  }


  /**
   * هر موقغ تاریخ انقضا اعتبار تغییر میکند
   */
  const handleChangeExpire = (e) => {
    setExpireDate(e);
  };

  /**
   * هر وقت تاریخ شروع اعتبار تغییر میکند
   */
  const handleChangeStart = (e) => {
    setStartDate(e);
    setExpireDate(jMoment(new Date(e).setHours(23, 59, 0, 0)).add(30, 'days'))
  };

  /**
   * 
   */
  const handleSubmitEnd = () => {
    setIsConfirmModalOpen(false);
  };

  const handleCloseModal = () => {
    if (isGroup) {
      taeidNahaeiGroup(false);
    } else {
      setIsConfirmModalOpen(false);
      setFoundUser(null);
    }
  };

  const handleCloseErrorsModal = () => {
    setIsResultErrorsOpen(false);
    setIsConfirmModalOpen(false);
    setTimeout(() => {
      setRowsWithError([]);
    }, 500);
  };
  const hintText =
    'در این بخش شما می‌توانید وجه حساب دیجیتال خود را به کاربر دیگر(عضو پاد) با تعریف محدودیت زمانی و اعمال محدودیت روی محل مصرف تفویض کنید. در صورت تفویض وجه، تا زمانی که مبلغ تفویض شده، مصرف نشده باشد، وجه از حساب دیجیتال شما کسر نمی‌شود.';

  return (
    <PageContainer
      title='تفویض وجه تکی/گروهی'
      className={classes.root}
      description={hintText}
      breadcrumbs={constBreadCrumbsTitle.DELEGATION_BY_MENU}
      meta={
        <>
          {(actionsList['multipleAccountDelegationBtn'] || actionsList['multipleAccountDelegationGuildBtn']) && (
            <Button
              className={classes.cardHeaderButton}
              onClick={() => navigate('/GroupDelegationList')}
              color="primary"
              variant="outlined"
              startIcon={<Icons icon='file' color="#2B3990" size="18" />}

            >
              گزارش تفویض وجه های گروهی
            </Button>
          )}
        </>
      }
    >

      {(!business?.userId || !balance) && actionsList['contentsDelegationPage'] ? <LoadingPage /> : null}

      {business?.userId && balance ? (
        <>
          {actionsList['contentsDelegationPage'] && (
            <FormProvider {...methods}>
              <form
                onSubmit={handleSubmit(isGroup ? onUploadGroup : onCheckContact)}
                className={classes.form}
                autoComplete="off"
              >
                <StepperKeeper
                  titles={[{ label: 'اطلاعات کلی', liner: true }, { label: 'محدودیت‌ها' }]}
                  onStepChanged={setActiveStep}
                  forceSelectedTabIndex={activeStep}
                  stepsToHideNext={'false'}
                  panels={[
                    <BaseInfo
                      isGroup={isGroup} // گروهی است یا خیر
                      setIsGroup={setIsGroup} // ست کردن حالت گروهی یا فردی
                      setMethodtype={setMethodtype} // ست کردن تب حالت دیجحیتال یا تفصیلی
                      methodType={methodType} // تفصیلی است یا دیجیتال
                      file={file} // فایل انتخاب شده - در حالت گروهی نمایش داده میشود
                      setFile={setFile} // ست کردن یا انتخاب فایل گروهی
                      startDate={startDate} // تاریخ شروع اعتبار
                      handleChangeStart={handleChangeStart} // زمانیکه تاریخ شروع اعتبار تغییر میکند
                      expireDate={expireDate} // تاریخ انقضا اعتبار
                      handleChangeExpire={handleChangeExpire} // زمانیکه تاریخ انقضا تغییر میکند
                      setSelectCheckBox={setSelectCheckBox} // چکباکس تفویض وجه بابت خرید
                      selectCheckBox={selectCheckBox} // چک باکس تفویض وجه بابت خرید - فقط در حالت فردی نمایش داده میشود
                      balance={balance} // اطلاعات موجودی حساب
                      captchaFormRef={captchaFormRef}
                      setCaptchaIdForm={setCaptchaIdForm}
                      setEnteredCaptchaForm={setEnteredCaptchaForm}
                      enteredCaptchaForm={enteredCaptchaForm}
                    />,
                    <Constraints
                      isGroup={isGroup} // گروهی است یا خیر
                      usageEnabled={usageEnabled} // اعمال محدودیت بر روی محل مصرف
                      setUsageEnabled={setUsageEnabled} // ست اعمال محدودیت بر روی محل مصرف
                      guilds={guilds} // محدودیت در حساب‌های تفصیلی (اصناف) کسب‌وکار - در چک باکس محدودیت بر روی محل مصرف است
                      setGuilds={setGuilds} /// محدودیت در حساب‌های تفصیلی (اصناف) کسب‌وکار - در چک باکس محدودیت بر روی محل مصرف است
                      usages={usages} // محدودیت در کسب‌وکار - در زیر باکس اعمال محدودیت رو محل مصرف فعال است
                      setUsages={setUsages} // / محدودیت در کسب‌وکار - در زیر باکس اعمال محدودیت رو محل مصرف فعال است
                      selectedProducts={selectedProducts} // محدودیت استفاده روی محصولات یا سرویس‌ها - زیر باکس محدودیت بر روی محل مصرف فعال میشود
                      setSelectedProducts={setSelectedProducts}  // محدودیت استفاده روی محصولات یا سرویس‌ها - زیر باکس محدودیت بر روی محل مصرف فعال میشود
                      usageLimitsEnabled={usageLimitsEnabled} // چک باکس اعمال محدودیت میزان مصرف در بازه زمانی
                      setUsageLimitsEnabled={setUsageLimitsEnabled} // اعمال محدودیت میزان مصرف در بازه زمانی
                      usagePeriodEnabled={usagePeriodEnabled} // اعمال بازه زمانی مصرف - در زیر باکس اعمال محدودیت میزان مصرف در بازه زمانی فعال میشود
                      setUsagePeriodEnabled={setUsagePeriodEnabled} // اعمال بازه زمانی مصرف - در زیر باکس اعمال محدودیت میزان مصرف در بازه زمانی فعال میشود
                      periodicEnabled={periodicEnabled} // اعمال تمدید خودکار دوره‌ای - 
                      setPeriodicEnabled={setPeriodicEnabled} // اعمال تمدید خودکار دوره‌ای - 
                    />,
                  ]}
                  formAction={
                    <Grid container item justifyContent="flex-end">
                      <div className={classes.containButton}>
                        <ButtonLoading
                          variant="contained"
                          color="primary"
                          loading={submitting || isCartableLoading}
                          name="بررسی اطلاعات"
                          type="submit"
                          disabled={submitting || isCartableLoading}
                        />

                      </div>
                    </Grid>
                  }
                />
              </form>
            </FormProvider>
          )}
        </>
      ) : null}

      {/* دیالوگ جزییات هست که بعد از کلیک بر روی دکمه بررسی اطلاعات نمایش داده میشود  */}
      <DetailsDg
        isConfirmModalOpen={isConfirmModalOpen}
        handleCloseModal={handleCloseModal}
        onClickTaeid={onClickTaeid}
        submitting={submitting}
        foundUser={foundUser}
        watch={watch}
        methods={methods}
        startDate={startDate}
        expireDate={expireDate}
        guilds={guilds}
        usages={usages}
        isGroup={isGroup}
        captchaRef={captchaRef}
        setCaptchaIdDialog={setCaptchaIdDialog}
        setEnteredCaptcha={setEnteredCaptcha}
        enteredCaptcha={enteredCaptcha}
        infoType={infoType}
        dataType={dataType}
      />

      {/* اگه هنگام آپلود فایل گروهی به خطای 415 برخورد کنیم این دیالوگ نمایش داده میشود */}
      <ErrorDelegationDg
        isResultErrorsOpen={isResultErrorsOpen}
        handleCloseErrorsModal={handleCloseErrorsModal}
        rowsWithError={rowsWithError}
        classes={classes}
      />

      {/* حساب از نوع کارتابلی باشد و بعد از عملیات تفویض موفق این دیالوگ نمایش داده میشود */}
      <CartableMessageDg
        isOpenDg={isOpenCartableMessageDg}
        setIsOpenDg={setIsOpenCartableMessageDg}
        requestId={requestId}
        isCartable={isCartable}
        isGroup={isGroup}
      />

      {/* دیالوگ تکراری */}
      {/* دیالوگی که کاربر در زمان درخواست گروهی تکراری ارسال میکند */}
      <RepeatitiveFileDg
        isLoadingAcceptReaptiveDg={isLoadingAcceptReaptiveDg}
        enteredCaptchaRepeat={enteredCaptchaRepeat}
        onRepeatGroupServiceCall={onRepeatUploadGroup}
        setIsOpenRepeativeDg={setIsOpenRepeativeDg}
        isOpenRepeativeDg={isOpenRepeativeDg}
        captchaDialogRef={captchaDialogRef}
        setCaptchaIdDialogRepeat={setCaptchaIdDialogRepeat}
        setEnteredCaptchaRepeat={setEnteredCaptchaRepeat}
      />
    </PageContainer>
  );
};



export default DelegationByMenu;
